import { Flex } from "antd"
import React from "react"

import { type Event } from "../../../types/types.ts"
import { CalendarMiniMonth } from "./CalendarMiniMonth.tsx"
import { CalendarMySchedule } from "./CalendarMySchedule.tsx"

interface CalendarSidebarProps {
  events: Event[]
  timezone: string
  userId?: string
  currentDate: Date
  onSelectDate: (date: Date) => void
  onSelectEvent: (id: string) => void
  onViewSchedule: () => void
}

// The Calendar 2.0 workspace sidebar — Mini Month Navigator and My Schedule
// today. Team Availability is a deliberately separate, later phase (needs its
// own team-roster fetch this page doesn't do yet); this shell holds whatever
// cards exist without reserving space or stubbing out what isn't built.
export function CalendarSidebar({
  events,
  timezone,
  userId,
  currentDate,
  onSelectDate,
  onSelectEvent,
  onViewSchedule
}: CalendarSidebarProps) {
  return (
    <Flex vertical gap={16} className={"w-[300px] shrink-0 overflow-y-auto"}>
      <CalendarMiniMonth
        currentDate={currentDate}
        events={events}
        timezone={timezone}
        onSelectDate={onSelectDate}
      />
      <CalendarMySchedule
        events={events}
        timezone={timezone}
        userId={userId}
        onSelectEvent={onSelectEvent}
        onViewAll={onViewSchedule}
      />
    </Flex>
  )
}
